<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'후기 보내기'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div v-if="is_loaded" style="flex: 1; padding:0 12px; margin-top: 20px; overflow-y: scroll; padding-bottom: 50px;">
            <div style="">
                <div style="display: flex;  gap: 8px;">
                    <div style="width: 40px; height: 40px; border-radius: 8px; border: 2px solid #d9d9d9; overflow: hidden;">
                        <img v-if="scheduleInfo.creator" style="object-fit: cover; width: 100%; height: 100%;" :src="$resourcePath + scheduleInfo.creator.image_path" alt="">
                    </div>
                    <div>
                        <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ scheduleInfo.title }}</div>
                        <div style="display: flex; align-items: center; gap: 4px;">
                            <div v-if="scheduleInfo.creator" style="font-size: 12px; font-weight: 500; line-height: 20px; color: #808080;">{{ scheduleInfo.creator.nic_name }}</div>
                            <img style="width: 14px;" :src="require('@/assets/img/blue_star.png')" alt="">
                        </div>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px;  display: flex; align-items: center; gap: 4px;">{{ $Util.getMMDDDayHangulStr(scheduleInfo.join_begin_date_time) }} <span style="width: 2px; height: 2px; border-radius: 50%; background-color: #808080;"></span> {{ scheduleInfo.place_name }}</div>
                        <!-- <div style="font-weight: 500; font-size: 12px; line-height: 20px;  display: flex; align-items: center; gap: 4px;">2025년 3월 25일 화요일<span style="width: 2px; height: 2px; border-radius: 50%; background-color: #808080;"></span> 록호풋살장 독옥점</div> -->
                    </div>
                </div>
            </div>
            <div style="margin-top: 40px;">
                <div style="font-weight: 500; font-size: 12px; line-height: 20px;">다시 할 만한 트레이닝인가요?</div>
                <div style="display: flex; margin-top: 12px; gap: 12px; flex-wrap: wrap;">
                    <InteractionOfBtnBackgroundColor style="border-radius: 12px;" :curType="review1" :btnType="REVIEW1.ONCE" originColor="#f5f5f5" changeColor="#d9d9d9" completeColor="var(--color-main)">
                        <div @click="setReview1(REVIEW1.ONCE)" style="padding: 8px 12px; font-weight: 500; font-size: 12px; line-height: 20px; border-radius: 12px;">한 번으로 만족해요</div>
                    </InteractionOfBtnBackgroundColor>
                    <InteractionOfBtnBackgroundColor style="border-radius: 12px;" :curType="review1" :btnType="REVIEW1.RETRY" originColor="#f5f5f5" changeColor="#d9d9d9" completeColor="var(--color-main)">
                        <div @click="setReview1(REVIEW1.RETRY)" style="padding: 8px 12px; font-weight: 500; font-size: 12px; line-height: 20px; border-radius: 12px;">다시 해볼 만해요</div>
                    </InteractionOfBtnBackgroundColor>
                    <InteractionOfBtnBackgroundColor style="border-radius: 12px;" :curType="review1" :btnType="REVIEW1.ALWAYS" originColor="#f5f5f5" changeColor="#d9d9d9" completeColor="var(--color-main)">
                        <div @click="setReview1(REVIEW1.ALWAYS)" style="padding: 8px 12px; font-weight: 500; font-size: 12px; line-height: 20px; border-radius: 12px;">꾸준히 하고 싶어요</div>
                    </InteractionOfBtnBackgroundColor>
                </div>
            </div>
            <div style="margin-top: 40px;">
                <div style="font-weight: 500; font-size: 12px; line-height: 20px;">어떤 부분이 좋았나요?</div>
                <div style="margin-top: 12px; display: flex; flex-direction: column; gap: 12px;">
                    <div @click="setReview2('유익함과 재미')" style="display: flex; align-items: center; gap: 16px;">
                        <div style="width: 24px; height: 24px; border-radius: 50%; border: 2px solid #bbbbbb; display: flex; justify-content: center; align-items: center;">
                            <div v-if="review2 === '유익함과 재미'" style="width: 14px; height: 14px; border-radius: 50%; background-color: var(--color-main);"></div>
                        </div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">유익함과 재미</div>
                    </div>
                    <div @click="setReview2('친절함과 열정')" style="display: flex; align-items: center; gap: 16px;">
                        <div style="width: 24px; height: 24px; border-radius: 50%; border: 2px solid #bbbbbb; display: flex; justify-content: center; align-items: center;">
                            <div v-if="review2 === '친절함과 열정'" style="width: 14px; height: 14px; border-radius: 50%; background-color: var(--color-main);"></div>
                        </div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">친절함과 열정</div>
                    </div>
                    <div @click="setReview2('섬세한 코칭')" style="display: flex; align-items: center; gap: 16px;">
                        <div style="width: 24px; height: 24px; border-radius: 50%; border: 2px solid #bbbbbb; display: flex; justify-content: center; align-items: center;">
                            <div v-if="review2 === '섬세한 코칭'" style="width: 14px; height: 14px; border-radius: 50%; background-color: var(--color-main);"></div>
                        </div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">섬세한 코칭</div>
                    </div>
                    <div @click="setReview2('트레이닝 내용')" style="display: flex; align-items: center; gap: 16px;">
                        <div style="width: 24px; height: 24px; border-radius: 50%; border: 2px solid #bbbbbb; display: flex; justify-content: center; align-items: center;">
                            <div v-if="review2 === '트레이닝 내용'" style="width: 14px; height: 14px; border-radius: 50%; background-color: var(--color-main);"></div>
                        </div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">트레이닝 내용</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 40px;">
                <div style="font-weight: 500; font-size: 12px; line-height: 20px;">편하게 후기 한 줄 남겨주세요.</div>
                <div style="margin-top: 12px;">
                    <textarea placeholder="내용을 적어주세요." v-model="reviewContents" style="border: 1px solid #ebebeb; resize: none; width: 100%; height: 100px; border-radius: 12px; background-color: #f5f5f5; outline: none; padding: 12px; font-size: 15px; line-height: 24px;"></textarea>
                </div>
            </div>
        </div>
        <div style="height: 104px; padding: 0 12px;">
            <div @click="submitReview" :style="{backgroundColor: isComplete ? '#210f03' : '#f5f5f5', color: isComplete ? '#fff' : '#d9d9d9'}" style="height: 56px; line-height: 56px; border-radius: 50px; background-color: #f5f5f5; text-align: center; margin-top: 8px; font-size: 14px; font-weight: 700;">트레이닝 후기 보내기</div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import InteractionOfBtnBackgroundColor from '@/components/common/InteractionOfBtnBackgroundColor'
import ResponseCode from '@/ResponseCode';
import {JOIN_SCHEDULE_TYPE} from "../../../Constants";

const REVIEW1 = {
    ONCE: '한 번으로 만족해요',
    RETRY: '다시 해볼 만해요',
    ALWAYS: '꾸준히 하고 싶어요'
}

export default {
    name: "SendReview",
    components: { MercenaryHeader, InteractionOfBtnBackgroundColor },
    props: {
        join_schedule_idx : {
            type : [Number, String],
            default : -1
        },
        completeAction: {
            type: Function,
            default: () => {}
        }
    },
    created() {
        this.getJoinSchedule();
    },
    computed: {
        isComplete() {
            if (this.review1 !== '' && this.review2 !== '' && this.reviewContents !== '') {
                return true
            } else {
                return false
            }
        }
    },
    data() {
        return {
            review1: '',
            review2: '',
            REVIEW1: REVIEW1,
            reviewContents: '',
            scheduleInfo : {},
            is_loaded : false,
        }
    },
    methods: {
        setReview1(review1Type) {
            this.review1 = review1Type
        },
        setReview2(review2Type) {
            this.review2 = review2Type;
        },
        async getJoinSchedule(){
            const parameters = {};
            parameters.is_open = '1';
            parameters.filter = 'joined_all';
            parameters.type = JOIN_SCHEDULE_TYPE.LESSON_SCHEDULE;
            parameters.is_with_creator = true;
            parameters.join_schedule_idx = this.join_schedule_idx;

            const res = await this.$Axios.get('/api/join/schedule/list', { params: parameters });
            this.is_loaded = true;
            this.scheduleInfo = res.data.join_schedules;
        },
        async submitReview() {
            if (!this.isComplete) {
                this.$GlobalStore.showAlert('모든 항목을 입력해주세요')
                return
            }

            this.$GlobalStore.showProgress()
            const formData = new FormData();
            formData.append('parentIdx', this.scheduleInfo.idx);
            formData.append('contents', this.reviewContents);
            formData.append('additional_info1', this.review2)
            formData.append('additional_info2', this.review1)
            formData.append('type', 'schedule');
            formData.append('mode', 'insert');
            // if (this.repeatScheduleIdx) formData.append('refer_idx', this.repeatScheduleIdx);

            const res = await this.$Axios.post('/api/soccerhow/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                await this.completeAction(true)
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.closeLastModal()
                // if (this.isShowTeamTrainingDetailWhenSave) this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: this.scheduleIdx });
            } else if (res.data.msg === ResponseCode.FAIL) {
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.showAlert(res.data.msg);
            }
        }
    }
}
</script>

<style scoped>
textarea::placeholder {
    font-weight: 500;
    font-size: 15px;
    color: #bbbbbb;
}
</style>